import React from "react";
import { Trans, translate } from "react-i18next";
import compose from "ramda/src/compose";
import { bool, string, func } from "prop-types";

import { Modal } from "shared/components";
import { Button, Link } from "shared/components";

import IconRepairExists from "../../../../assets/svg/reparo-em-andamento.svg";
import styles from "./styles.css";

const ModalRepairExists = ({
  t,
  isCurrentStep,
  onReset,
  protocol,
  messageKey,
}) => {
  return (
    <Modal isOpen={isCurrentStep} onClose={onReset}>
      <div className={styles.rootSuccess}>
        <img src={IconRepairExists} width="98px" alt="" />
        <p className={styles.textSuccess}>{t(messageKey)}</p>
        <span>
          <Trans i18nKey="MSG_0190">
            <strong>{{ protocolo: protocol }}</strong>
          </Trans>
        </span>

        <div className={styles.actions}>
          <Link to="/incident-manager">{t("MSG_0119")}</Link>

          <Button
            relevance="normal"
            type="submit"
            callToAction
            onClick={onReset}
          >
            {t("MSG_0192")}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

ModalRepairExists.propTypes = {
  isOpen: bool.isRequired,
  onClose: func.isRequired,
  protocol: string,
};

ModalRepairExists.defaultPropTypes = {
  protocol: "",
  onClose: null,
};

const enhance = compose(translate());

export default enhance(ModalRepairExists);



// WEBPACK FOOTER //
// ./src/components/RepairWizard/components/ModalRepairExists/index.js